// Module
var code = "<script>let $DisplayPrice</script> <div class=\"molecule-display-price-invoice\"> <atom-text>{{ $DisplayPrice.outstandingTotal() | apiValue | currency }}</atom-text> </div> ";
// Exports
module.exports = code;